import type { IReactSelectOptions } from '../interfaces/reactSelectOptions';
import { translateKey } from '../../translate';
import { DropdownAsyncLoadInput } from '../fields/DropdownAsyncLoad';

export interface ISearchableEnumDropdown<E> {
    automation?: string;
    enumTranslationName?: string;
    error?: string;
    isSorted?: boolean;
    jsEnum: E;
    newstyles?: boolean;
    onChange: (value: E[keyof E] | null, label?: string) => void;
    onDoValidate?: () => Promise<void>;
    placeholder?: string;
    value: E[keyof E] | null;
}

export function SearchableEnumDropdown<E extends {}>(props: ISearchableEnumDropdown<E>) {
    return (
        <DropdownAsyncLoadInput<string>
            automation={props.automation}
            error={props.error}
            loadOptions={async (searchText) => await loadOptions(searchText)}
            newstyles={props.newstyles}
            onChange={async (value, label) => props.onChange(value as unknown as E[keyof E], label)}
            onDoValidate={props.onDoValidate}
            placeholder={props.placeholder}
            value={props.value as unknown as string}
        />
    );

    async function loadOptions(searchText: string) {
        const regExp = new RegExp(searchText, 'i'); // search text case insensitive

        const options = Object.values<string>(props.jsEnum).map((enumValue) => {
            return {
                value: enumValue,
                label: props.enumTranslationName
                    ? translateKey(`${props.enumTranslationName}Enum.${enumValue}`)
                    : enumValue,
            };
        });

        if (!searchText && props.isSorted) {
            return options;
        }

        return options
            .filter((option) => !searchText || option.label.search(regExp) !== -1)
            .sort((a, b) => a.label.localeCompare(b.label)) as IReactSelectOptions[];
    }
}
